import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import MainRoutes from "./routes";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <MainRoutes />
    </BrowserRouter>
  );
}

export default App;
